export default __webpack_public_path__ + "static/media/psm10001.10f61255.png";